import React, { useEffect, useState } from "react";
import RecruitmentPage from "../../../../entities/DashboardPage/HRModule/Recruitment";
import AuthService from "../../../../api/AuthService";
// eslint-disable-next-line import/default
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";

const Recruitment = () => {

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [permission, setPermission] = useState(null);
  const role = localStorage.getItem("role");
  const employeeId = localStorage.getItem("employeeId");

  // Fetch permissions from API only for Employee role
  const fetchPermissions = async () => {
    if ((role === "Employee" || role === "employee") && employeeId) {
      try {
        const permissionResult = await AuthService.getEmployeePermission(employeeId);
        if (permissionResult?.success && permissionResult?.data) {
          const permissions = permissionResult?.data;
          setPermission(permissions);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    } else {
      // For Admin/SuperAdmin, use localStorage
      const permissionObj = localStorage.getItem("permission");
      setPermission(permissionObj ? JSON.parse(permissionObj) : null);
    }
  };

  useEffect(() => {
    fetchPermissions();
    
    // Listen for permission updates
    const handlePermissionUpdate = () => {
      fetchPermissions();
    };
    
    window.addEventListener("permissionUpdated", handlePermissionUpdate);
    return () => {
      window.removeEventListener("permissionUpdated", handlePermissionUpdate);
    };
  }, []);

  useEffect(() => {
    if (permission !== null || role !== "Employee" && role !== "employee") {
      getRecruitment("",page);
    }
  }, [page, permission])
  const getRecruitment = async (text, page) => {
    LoaderHelper.loaderStatus(true);


    try {
      const result = await AuthService.getRecruitmentData(text,page);
      if (result?.success) {
        let recruitments = result?.data?.recruitments || [];
        
        // Filter data based on permissions for Employee role
        if ((role === "Employee" || role === "employee") && employeeId && permission) {
          const hasViewPermission = permission?.recruitment?.isView === true;
          const hasEditPermission = permission?.recruitment?.isEdit === true;
          
          // If employee has edit permission, show all recruitments (like admin)
          if (hasEditPermission) {
            setTotal(result?.data?.total);
          } else if (hasViewPermission) {
            // If only view permission, show only own data (if applicable)
            // Note: Recruitment might not have employee filter, so show all if view permission
            setTotal(result?.data?.total);
          } else {
            // No view permission, show nothing
            recruitments = [];
            setTotal(0);
          }
        } else {
          setTotal(result?.data?.total);
        }
        
        setData(recruitments);
        setFilteredData(recruitments);
        LoaderHelper.loaderStatus(false);

      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const handleSearch =(text) => {
    if (text){
      getRecruitment(text);
    }
  }


  return (
    
    <RecruitmentPage data={filteredData.length > 0 ? filteredData : data} permission={permission} role={role} handleSearch={handleSearch} page={page} total={total} setPage={setPage}/>
  )

}

export default Recruitment;
